// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function argentineOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {

  return {
    country: 'ar',
    document_type: userInputValues['argentineDocumentType'],
    document: userInputValues['argentineDocument'],
    zipcode: userInputValues['argentineZipcode'],
    state: userInputValues['argentineState'],
    city: userInputValues['argentineCity'],
    address: userInputValues['argentineAddress'],
    street_number: userInputValues['argentineStreetNumber'],
    street_complement: userInputValues['argentineStreetComplement'],
    phone_number: userInputValues['argentinePhoneNumber'],
  };
}
